import styled from 'styled-components'
import { LockAlt } from '@styled-icons/boxicons-solid/LockAlt'

/*======================== React component ===================================*/

const PreviewText = (): JSX.Element => {
  return (
    <Row>
      <Text>{'PREVIEW'}</Text>
      <LockIcon />
    </Row>
  )
}

export default PreviewText

/*======================== Styled components =================================*/

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const LockIcon = styled(LockAlt)`
  height: 15px;
  margin-left: 5px;
`

const Text = styled.div`
  font-size: 13px;
  color: white;
`
